import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import LoadingLayer from '../../controls/LoadingLayer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'react-bootstrap-button-loader';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ExceptionForm from './ExceptionForm';
import moment from "moment";
import "moment/locale/fr";
import { loadLocalization } from '../../../utils/kendoLocalization';
import { isIOS, formatDate } from '../../../utils';
import AlertAlgo from '../../controls/AlertSnack'
import * as StatusCode from '../../../scripts/StatusCode';
import { getExceptionList, deleteException } from '../../../actions/availability';
import i18next from 'i18next';
import styles from '../../../styles/scheduleAvailability.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashXmark } from "@fortawesome/pro-duotone-svg-icons";

loadLocalization();
moment.locale("fr");

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divForm: {
        padding: '10px'
    },
    date: {
        marginBottom: '15px'
    },
    listItem: {
        borderTop: '1px solid #e1e1e1'
    },
    spanLabel: {
        fontWeight: 'bold'
    },
    spanValue: {
        marginLeft: '5px',
        marginRight: '15px'
    },
    row: {
        margin: '5px',
        display: 'table'
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: '#3f51b5 !important'
    },
}));

export function Exception(props) {
    const classes = useStyles();

    const [data, setData] = useState(props.data);
    const [id, setId] = useState(0);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [openExceptionForm, setOpenExceptionForm] = useState(false);
    const [isProcessing, setIsProcessing] = useState(true);
    const [titleExceptionForm, setTitleExceptionForm] = useState('');

    const alertRef = useRef(null);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        loadData();
        resizeForm();
    }, []);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - menu - offSet;

            const element = document.querySelector('#divAvailabilityException');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    const loadData = async () => {
        setIsProcessing(true);
        const response = await getExceptionList();

        if (response != null && response.status == StatusCode.STATUS_OK) {
            const formattedData = [];

            response.result.forEach(x => {
                x.startDate = formatDate(x.startDate, 'date');
                x.endDate = x.endDate != null ? formatDate(x.endDate, 'date') : null;
                x.startTimeDisplay = x.startTime != null ? formatDate(new Date(x.startTime), 'time') : null;
                x.endTimeDisplay = x.endTime != null ? formatDate(new Date(x.endTime), 'time') : null;
                formattedData.push(x);
            })

            setData(formattedData);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }

        setIsProcessing(false);
    }

    const handleReloadException = () => {
        setOpenExceptionForm(false);
        showMessageSuccess(i18next.t('scheduleAvailability:exception.message.success'));
        loadData();
    }

    const handleDelete = async () => {
        const response = await deleteException(id);

        if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
            // Error
            showMessageError(i18next.t('error:generic-error'));
            return;
        }

        setOpenConfirmDelete(false);
        showMessageSuccess(i18next.t('scheduleAvailability:exception.message.deleteSuccess'));
        loadData();
    }

    const showMessageSuccess = (msg) => {
        alertRef.current.showMessageSuccess(msg);
    }

    const showMessageError = (msg) => {
        alertRef.current.showMessageError(msg);
    }

    const handleOpenConfirmDelete = (id) => {
        setId(id);
        setOpenConfirmDelete(true);
    }

    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
    }

    const handleAdd = () => {
        setId(0);
        setTitleExceptionForm(i18next.t('scheduleAvailability:exception.titleAdd'));
        setOpenExceptionForm(true);
    }

    const handleEdit = (id) => {
        setTitleExceptionForm(i18next.t('scheduleAvailability:exception.titleEdit'));
        setId(id);
        setOpenExceptionForm(true);
    }

    const handleCloseExceptionForm = () => {
        setOpenExceptionForm(false);
    }

    return (
        <div id="divAvailabilityException" className={styles.konekCard} style={{ paddingTop: '10px', zIndex: '1' }}>
            <LoadingLayer isActive={isProcessing}>
                <List>
                    {data != null && data.map((obj, index) =>
                        <ListItem key={index} className="listItem" onClick={() => handleEdit(obj.id)}>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.partial')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.isPartial ? i18next.t('scheduleAvailability:exception.list.yes') : i18next.t('scheduleAvailability:exception.list.no')}
                                            </span>
                                        </span>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.startDate')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.startDate}
                                            </span>
                                        </span>
                                        {obj.endDate && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.endDate')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.endDate}
                                            </span>
                                        </span>}
                                        {obj.startTime && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.startTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.startTimeDisplay}
                                            </span>
                                        </span>}
                                        {obj.endTime && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.endTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.endTimeDisplay}
                                            </span>
                                        </span>}
                                    </React.Fragment>
                                }
                                secondary={
                                    obj.comment && <React.Fragment>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:exception.list.comment')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.comment}
                                            </span>
                                        </span>
                                    </React.Fragment>
                                }
                            />
                            <ListItemSecondaryAction className={classes.divAction}>
                                <IconButton edge="end" aria-label="delete" className={classes.icons} onClick={() => handleOpenConfirmDelete(obj.id)}>
                                    <FontAwesomeIcon icon={faTrashXmark} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    )}
                </List>
                <Fab color="primary" aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={() => handleAdd()} >
                    <AddIcon />
                </Fab>
                <Dialog
                    open={openConfirmDelete}
                    onClose={handleCloseConfirmDelete}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">
                        Confirmation
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {i18next.t('common:confirmDelete')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => handleDelete()} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('buttons:yes')}
                        </Button>
                        <Button onClick={handleCloseConfirmDelete} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('buttons:no')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullScreen open={openExceptionForm} onClose={handleCloseExceptionForm} TransitionComponent={Transition}>
                    <div data-id="headerExceptionForm">
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={handleCloseExceptionForm} aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={classes.title}>
                                    {titleExceptionForm}
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </div>

                    <div className={styles.rootEditException}>
                        <ExceptionForm handleReloadException={handleReloadException} data={data} exceptionId={id} />
                    </div>
                </Dialog>
            </LoadingLayer>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'error'], { wait: true })(Exception);